import { AssignmentOutlined as IntervalCommissionsButton } from '@mui/icons-material';
import { Stack, Tooltip } from '@mui/material';
import { isNumber } from 'lodash';
import { Fragment } from 'react';
import { useTranslation } from 'react-i18next';

import { StylizedNumber } from 'components';
import { IntervalCommission } from 'types';

type Props = {
  commission?: number;
  payoutCommission?: number;
  intervalCommissions?: IntervalCommission[];
  onIntervalCommissionsButtonClick?: (e: React.SyntheticEvent) => void;
};

export const CommissionInfo: React.FC<Props> = ({
  commission,
  payoutCommission,
  intervalCommissions,
  onIntervalCommissionsButtonClick,
}) => {
  const { t } = useTranslation();

  return (
    <Stack direction="row" spacing={1}>
      {isNumber(commission) && (
        <Fragment>
          <StylizedNumber value={commission} unit="%" />
          {!!intervalCommissions?.length && (
            <Tooltip title={t('features.commission.configuration')}>
              <IntervalCommissionsButton
                sx={{ ml: 1 }}
                fontSize="small"
                color="primary"
                className="tw-cursor-pointer"
                onClick={onIntervalCommissionsButtonClick}
              />
            </Tooltip>
          )}
        </Fragment>
      )}
      {isNumber(commission) && isNumber(payoutCommission) && <span>{'/'}</span>}
      {isNumber(payoutCommission) && (
        <StylizedNumber value={payoutCommission} unit="%" />
      )}
    </Stack>
  );
};
